var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.app && _vm.app.showBreadcrumb)?_c('v-breadcrumbs',{staticClass:"mb-2",attrs:{"items":_vm.breadcrumbs,"divider":"/"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }